module.exports = __webpack_public_path__ + "static/sune-DND3_FnP-0b01ca9d007ab3f8950887010a1cefa5.jpg";